// Individual hi-res panels sliced from the 6-up NOOR collage, plus the new
// NOOR retail-display photo. Each is served as WebP from /public/noor/
// (10× smaller than the source PNGs — original PNGs retained for fallback).

export const BOTTLE_FRONT = "/noor/front.webp";        // col 0, row 0 — front label (hero LCP)
export const BOTTLE_BACK_TALL = "/noor/back-tall.webp"; // col 1, row 0 — tall back
export const BOTTLE_NOM = "/noor/nom-info.webp";       // col 2, row 0 — NOM info side
export const BOTTLE_MEXICO = "/noor/mexico.webp";      // col 0, row 1 — Made in Mexico split
export const BOTTLE_CRYSTAL = "/noor/crystal.webp";    // col 1, row 1 — crystal etching close-up
export const BOTTLE_SIDE = "/noor/side-label.webp";    // col 2, row 1 — NOOR side label

// AI-generated NOOR six-bottle kraft packaging crate (placeholder until real photography lands).
export const NOOR_BOX = "/noor/box.webp";

// New on-shelf retail photo showing the bottle top-down with QR code etched in rose-gold.
export const NOOR_RETAIL =
  "https://customer-assets.emergentagent.com/job_agave-blanco/artifacts/4vi9trum_aff47298.png";
